var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-container',{staticClass:"page-task-filter-list-container"},[_c('el-header'),_c('el-main',[_c('TaskFilterListTable',{attrs:{"taskType":_vm.taskType}})],1),_c('el-footer',[_c('Footer')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }